jQuery(function ($) {
    var loadMap = {}, firstLoaderAdding = true;

    function hasClass(ele, cls) {
        return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
    }

    function fixLoaders() {
        jQuery.each(loadMap, function (i, loader) {
            var element = loader.data('element');
            if (loader.hasClass('global-loader')) {
                var offset = element.offset();
                if (offset) {
                    loader.css({
                        top: offset.top - jQuery(document).scrollTop(),
                        left: offset.left - jQuery(document).scrollLeft(),
                        right: 'auto',
                        bottom: 'auto',
                        width: element.outerWidth(),
                        height: element.outerHeight()
                    });
                }
            }
        });
    }

    window.Page = {
        scrollTo: function (dest, time, offset) {
            setTimeout(function () {
                var $offset = jQuery(dest).offset();
                if ($offset) {
                    jQuery('html, body').animate({
                            scrollTop: $offset.top + (offset || 0)
                        }, time || 600, 'swing'
                    );
                }
            }, 1);
        },
        getLanguage: function () {
            var matches = jQuery('html').get(0).className.match(/language-(\w{2})/);
            if (matches) {
                return matches[1];
            }

            return false;
        },
        isRTL: function () {
            return hasClass(document.documentElement, 'is-rtl');
        },
        tagIsFree: function (tag) {
            return typeof(loadMap[tag]) === 'undefined';
        },
        startLoad: function (tag, element) {
            if (element === 'popup') {
                element = "#colorbox";
            }
            element = jQuery(element);
            //console.log('Loading ', tag, '...');
            if (element.is('.action-loader')) {
                loadMap[tag] = element;
                element.addClass('active');
            } else {
                var offset = element.offset();
                if (offset) {
                    loadMap[tag] = jQuery('<div class="global-loader">&nbsp;</div>').appendTo('body')
                        .show().data('element', element);

                    if (firstLoaderAdding) {
                        firstLoaderAdding = false;
                        jQuery(window).on('resize scroll', fixLoaders);
                    }

                    fixLoaders();
                }
            }
        },
        finishLoad: function (tag) {
            //console.log('Finished loading ', tag);
            var element = loadMap[tag];
            if (element && element.length > 0) {
                if (element.is('.action-loader')) {
                    element.removeClass('active');
                } else {
                    element.remove();
                }

                delete loadMap[tag];
            }
        },
        load: function (url) {
            document.location = url ? url : document.location;
        },
        inNewTab: function (url) {
            var win = window.open(url, '_blank');
            win.focus();

        },
        isAtPath: function (path) {
            return document.location.pathname === path;
        },
        isSingle: function (slug) {
            return slug ? hasClass(document.body, 'single-' + slug) : hasClass(document.body, 'single');
        },
        isTemplate: function (slug) {
            return slug ? hasClass(document.body, 'page-template-' + slug) : hasClass(document.body, 'page-template');
        },
        isCategory: function (slug) {
            return slug ? hasClass(document.body, 'category-' + slug) : hasClass(document.body, 'category');
        },
        isSSL: function () {
            return document.location.protocol === 'https:';
        },
        closePopups: function () {
            jQuery("#cboxOverlay.pre-show, #colorbox.pre-show").remove();
            jQuery.colorbox.close();
        },
        getSearchParameters: function () {
            if (window.location.search.length) {
                var searchArr = window.location.search.substr(1).split("&"),
                    result = {};

                searchArr.forEach(function (item) {
                    var tmp = item.split("=");
                    result[tmp[0]] = decodeURIComponent(tmp[1]);
                });

                return result;
            } else {
                return {};
            }
        }
    };
});